// LUMINA · pages/ProfileListPage.jsx
// Phase 104 — 档案列表 + 新建/编辑/删除

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { C, IS, LS, BG, BO } from '../constants/baziData';

const API = "/api";

export default function ProfileListPage({ user, lang }) {
  const navigate = useNavigate();
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState("");

  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({
    name: "", gender: "male", birth_year: "", birth_month: "",
    birth_day: "", birth_hour: "-1", birth_location: "", notes: ""
  });

  const getHeaders = () => {
    const t = localStorage.getItem("lumina_token");
    return { "Authorization": `Bearer ${t || ""}`, "Content-Type": "application/json" };
  };

  const loadProfiles = async () => {
    setLoading(true);
    try {
      try { await fetch(`${API}/profiles/migrate-reports`, { method: "POST", headers: getHeaders() }); } catch(e) {}
      const r = await fetch(`${API}/profiles`, { headers: getHeaders() });
      if (r.ok) setProfiles(await r.json());
      else if (r.status === 403) setMsg("Please log in");
    } catch (e) { setMsg(e.message); }
    setLoading(false);
  };

  useEffect(() => { if (user) loadProfiles(); }, [user]);

  const resetForm = () => {
    setForm({ name: "", gender: "male", birth_year: "", birth_month: "",
      birth_day: "", birth_hour: "-1", birth_location: "", notes: "" });
    setEditId(null);
  };

  const openEdit = (p) => {
    setForm({
      name: p.name, gender: p.gender,
      birth_year: String(p.birth_year), birth_month: String(p.birth_month),
      birth_day: String(p.birth_day), birth_hour: String(p.birth_hour),
      birth_location: p.birth_location || "", notes: p.notes || ""
    });
    setEditId(p.id);
    setShowForm(true);
  };

  const submit = async () => {
    const body = {
      name: form.name, gender: form.gender,
      birth_year: parseInt(form.birth_year), birth_month: parseInt(form.birth_month),
      birth_day: parseInt(form.birth_day), birth_hour: parseInt(form.birth_hour),
      birth_location: form.birth_location || null, notes: form.notes || null
    };
    try {
      const url = editId ? `${API}/profiles/${editId}` : `${API}/profiles`;
      const method = editId ? "PATCH" : "POST";
      const r = await fetch(url, { method, headers: getHeaders(), body: JSON.stringify(body) });
      if (r.ok) {
        setMsg(editId ? "档案已更新" : "档案已创建");
        setShowForm(false); resetForm(); loadProfiles();
      } else {
        const d = await r.json();
        setMsg(d.detail || "Error");
      }
    } catch (e) { setMsg(e.message); }
  };

  const deleteProfile = async (id, name) => {
    if (!window.confirm(`删除档案「${name}」？报告不会被删除。`)) return;
    try {
      const r = await fetch(`${API}/profiles/${id}`, { method: "DELETE", headers: getHeaders() });
      if (r.ok) { setMsg(`已删除: ${name}`); loadProfiles(); }
      else { const d = await r.json(); setMsg(d.detail || "Error"); }
    } catch (e) { setMsg(e.message); }
  };

  const setPrimary = async (id) => {
    try {
      await fetch(`${API}/profiles/${id}`, {
        method: "PATCH", headers: getHeaders(), body: JSON.stringify({ is_primary: true })
      });
      loadProfiles();
    } catch (e) { setMsg(e.message); }
  };

  if (!user) return <div style={{ padding: 40, color: C.mist3 }}>请先登录</div>;

  const T = lang === "zh" ? {
    title: "我的档案", subtitle: "管理您和家人的命盘档案",
    add: "+ 新建档案", name: "姓名", gender: "性别",
    male: "男", female: "女", year: "年", month: "月", day: "日",
    hour: "时 (-1=未知)", location: "出生地", notes: "备注",
    save: "保存", cancel: "取消", delete: "删除",
    setPrimary: "设为主档案", primary: "主档案",
    viewDetail: "查看", noData: "还没有档案，点击上方按钮创建",
    edit: "编辑", reports: "份报告"
  } : {
    title: "My Profiles", subtitle: "Manage birth charts for yourself and family",
    add: "+ New Profile", name: "Name", gender: "Gender",
    male: "Male", female: "Female", year: "Year", month: "Month", day: "Day",
    hour: "Hour (-1=unknown)", location: "Birthplace", notes: "Notes",
    save: "Save", cancel: "Cancel", delete: "Delete",
    setPrimary: "Set as Primary", primary: "Primary",
    viewDetail: "View", noData: "No profiles yet. Create one above.",
    edit: "Edit", reports: "reports"
  };

  return (
    <div style={{ minHeight: "100vh", background: C.bg, padding: "40px 20px" }}>
      <div style={{ maxWidth: 720, margin: "0 auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
          <div>
            <h2 style={{ fontSize: 24, color: C.gold, fontFamily: "'Inter','Montserrat',sans-serif", fontWeight: 300, margin: 0 }}>{T.title}</h2>
            <p style={{ fontSize: 13, color: C.mist4, margin: "4px 0 0" }}>{T.subtitle}</p>
          </div>
          <button onClick={() => { resetForm(); setShowForm(true); }} style={{
            background: C.gold, border: "none", borderRadius: 8, padding: "10px 20px",
            color: "#fff", fontSize: 14, fontWeight: 600, cursor: "pointer"
          }}>{T.add}</button>
        </div>

        {msg && <div style={{ fontSize: 13, color: C.sage, marginBottom: 12 }}>{msg}</div>}

        {showForm && (
          <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 300 }}
            onClick={() => setShowForm(false)}>
            <div style={{ background: "rgba(255,255,255,.95)", border: "1px solid rgba(212,175,55,.16)", borderRadius: 14, padding: 28, maxWidth: 420, width: "100%", maxHeight: "90vh", overflow: "auto" }}
              onClick={e => e.stopPropagation()}>
              <h3 style={{ fontSize: 18, color: C.gold, marginBottom: 16, fontFamily: "'Inter','Montserrat',sans-serif" }}>
                {editId ? T.edit : T.add}
              </h3>
              <Field label={T.name} value={form.name} onChange={v => setForm({ ...form, name: v })} />
              <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
                <select value={form.gender} onChange={e => setForm({ ...form, gender: e.target.value })}
                  style={{ ...IS, flex: 1 }}>
                  <option value="male">{T.male}</option>
                  <option value="female">{T.female}</option>
                </select>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 8, marginBottom: 10 }}>
                <FieldSmall label={T.year} value={form.birth_year} onChange={v => setForm({ ...form, birth_year: v })} />
                <FieldSmall label={T.month} value={form.birth_month} onChange={v => setForm({ ...form, birth_month: v })} />
                <FieldSmall label={T.day} value={form.birth_day} onChange={v => setForm({ ...form, birth_day: v })} />
                <FieldSmall label={T.hour} value={form.birth_hour} onChange={v => setForm({ ...form, birth_hour: v })} />
              </div>
              <Field label={T.location} value={form.birth_location} onChange={v => setForm({ ...form, birth_location: v })} />
              <Field label={T.notes} value={form.notes} onChange={v => setForm({ ...form, notes: v })} />
              <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
                <button onClick={submit} style={{ ...BG, flex: 1 }}>{T.save}</button>
                <button onClick={() => setShowForm(false)} style={{ ...BO, flex: 1 }}>{T.cancel}</button>
              </div>
            </div>
          </div>
        )}

        {loading ? (
          <div style={{ textAlign: "center", padding: 40, color: C.mist4 }}>Loading...</div>
        ) : profiles.length === 0 ? (
          <div style={{ textAlign: "center", padding: 60, color: C.mist4, fontSize: 14 }}>{T.noData}</div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {profiles.map(p => (
              <div key={p.id} style={{
                background: "rgba(255,255,255,.72)", border: `1px solid ${p.is_primary ? "rgba(212,175,55,.35)" : "rgba(212,175,55,.12)"}`,
                borderRadius: 12, padding: "16px 20px", display: "flex", alignItems: "center",
                justifyContent: "space-between", backdropFilter: "blur(12px)"
              }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                    <span style={{ fontSize: 16, fontWeight: 500, color: C.mist }}>
                      {p.gender === "male" ? "👤" : "👩"} {p.name}
                    </span>
                    {p.is_primary && (
                      <span style={{ background: C.goldGlow, color: C.gold, fontSize: 10, padding: "2px 8px", borderRadius: 9999, border: `0.5px solid ${C.goldDim}` }}>{T.primary}</span>
                    )}
                  </div>
                  <div style={{ fontSize: 12, color: C.mist4 }}>
                    {p.birth_year}/{String(p.birth_month).padStart(2, '0')}/{String(p.birth_day).padStart(2, '0')}
                    {p.birth_hour >= 0 ? ` ${p.birth_hour}:00` : ""}
                    {p.birth_location ? ` · ${p.birth_location}` : ""}
                  </div>
                  <div style={{ fontSize: 11, color: C.mist4, marginTop: 2 }}>
                    {p.reports_count} {T.reports}
                    {p.notes ? ` · ${p.notes}` : ""}
                  </div>
                </div>
                <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
                  <button onClick={() => navigate(`/profile/${p.id}`)} style={{
                    background: "transparent", border: `0.5px solid ${C.gold}`, borderRadius: 6,
                    padding: "6px 14px", fontSize: 12, color: C.gold, cursor: "pointer"
                  }}>{T.viewDetail}</button>
                  {!p.is_primary && (
                    <button onClick={() => setPrimary(p.id)} style={{
                      background: "transparent", border: `0.5px solid ${C.mist4}`, borderRadius: 6,
                      padding: "6px 10px", fontSize: 11, color: C.mist4, cursor: "pointer"
                    }}>{T.setPrimary}</button>
                  )}
                  <button onClick={() => openEdit(p)} style={{
                    background: "transparent", border: `0.5px solid ${C.cyan}`, borderRadius: 6,
                    padding: "6px 10px", fontSize: 11, color: C.cyan, cursor: "pointer"
                  }}>{T.edit}</button>
                  <button onClick={() => deleteProfile(p.id, p.name)} style={{
                    background: "transparent", border: `0.5px solid ${C.stress}`, borderRadius: 6,
                    padding: "6px 10px", fontSize: 11, color: C.stress, cursor: "pointer"
                  }}>{T.delete}</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function Field({ label, value, onChange }) {
  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ fontSize: 11, color: C.mist4, marginBottom: 3 }}>{label}</div>
      <input value={value} onChange={e => onChange(e.target.value)}
        style={{ ...IS, width: "100%" }} />
    </div>
  );
}

function FieldSmall({ label, value, onChange }) {
  return (
    <div style={{ marginBottom: 4 }}>
      <div style={{ fontSize: 10, color: C.mist4, marginBottom: 2 }}>{label}</div>
      <input value={value} onChange={e => onChange(e.target.value)}
        style={{ ...IS, width: "100%", fontSize: 12 }} />
    </div>
  );
}
